import { useTranslation } from 'react-i18next';

export default function BooleanIcon({
  value,
  showText,
}: {
  value: boolean | undefined;
  showText?: boolean;
}): JSX.Element {
  const { t } = useTranslation();
  const label = value ? t('yes').toUpperCase() : t('no').toUpperCase();

  if (showText) return <span>{label}</span>;

  return (
    <span title={label} aria-label={label}>
      {value ? '✔️' : '❌'}
    </span>
  );
}
